import {
  MapPin,
  Phone,
  Mail,
  Clock,
  Facebook,
  Linkedin,
  Twitter,
} from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-slate-950 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="flex items-center justify-center">
                <img
                  src="/images/logo.jpg"
                  alt="TCLA-X Logo"
                  width={50}
                  height={50}
                />
              </div>
              <div className="flex flex-col">
                <span className="font-bold text-xl">TCLA-X</span>
                <span className="text-xs text-gray-400 uppercase tracking-wide">
                  Empower • Elevate • Excel
                </span>
              </div>
            </div>
            <p className="text-sm text-gray-300">
              Transform. Excel. Lead. Empowering leaders and organizations
              across Africa through world-class training programs.
            </p>
            <div className="text-sm text-gray-400">
              <p>TCLA-X Limited</p>
              <p>Government of Kenya Registered Company</p>
              <p>Reg. No: P052445464L</p>
            </div>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-8 h-8 bg-background/10 rounded-lg flex items-center justify-center hover:bg-primary transition-colors"
              >
                <Linkedin className="w-4 h-4" />
              </a>
              <a
                href="#"
                className="w-8 h-8 bg-background/10 rounded-lg flex items-center justify-center hover:bg-primary transition-colors"
              >
                <Twitter className="w-4 h-4" />
              </a>
              <a
                href="#"
                className="w-8 h-8 bg-background/10 rounded-lg flex items-center justify-center hover:bg-primary transition-colors"
              >
                <Facebook className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg">Quick Links</h3>
            <ul className="grid grid-cols-3 md:grid-cols-2 gap-x-4 gap-y-2 text-xs sm:text-sm text-gray-300">
              <li>
                <Link
                  to="/about"
                  className="text-gray-300 hover:text-primary transition-smooth"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-gray-300 hover:text-primary transition-smooth"
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/programs"
                  className="text-gray-300 hover:text-primary transition-smooth"
                >
                  Programs
                </Link>
              </li>
              <li>
                <Link
                  to="/impact"
                  className="text-gray-300 hover:text-primary transition-smooth"
                >
                  Our Impact
                </Link>
              </li>
              <li>
                <Link
                  to="/methodology"
                  className="text-gray-300 hover:text-primary transition-smooth"
                >
                  Methodology
                </Link>
              </li>
              <li>
                <Link
                  to="/resources"
                  className="text-gray-300 hover:text-primary transition-smooth"
                >
                  Resources
                </Link>
              </li>
              {/* <li><Link to="/careers" className="text-gray-300 hover:text-primary transition-smooth">Career Opportunities</Link></li> */}
              <li>
                <Link
                  to="/contact"
                  className="text-gray-300 hover:text-primary transition-smooth"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Training Categories */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg">Training Categories</h3>
            <ul className="grid grid-cols-2 md:grid-cols-1 gap-x-4 gap-y-2 text-xs sm:text-sm text-gray-300">
              <li>
                <Link
                  to="/services"
                  className="hover:text-primary transition-smooth"
                >
                  Leadership Development
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="hover:text-primary transition-smooth"
                >
                  Project Management
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="hover:text-primary transition-smooth"
                >
                  Professional Development
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="hover:text-primary transition-smooth"
                >
                  Communication Excellence
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="hover:text-primary transition-smooth"
                >
                  Digital Transformation
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Information */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg">Contact Information</h3>
            <div className="space-y-3 text-sm">
              <div className="flex items-start space-x-3">
                <MapPin size={16} className="text-primary mt-1 flex-shrink-0" />
                <div>
                  <p className="text-gray-300">
                    41 Forest Close, Off Kenyatta Road
                  </p>
                  <p className="text-gray-300">P.O. Box 10385-00400</p>
                  <p className="text-gray-300">
                    Tom Mboya Street, Nairobi, Kenya
                  </p>
                </div>
              </div>

              <div className="flex items-center space-x-3">
                <Phone size={16} className="text-primary flex-shrink-0" />
                <p className="text-gray-300">+254780319499</p>
              </div>

              <div className="flex items-center space-x-3">
                <Mail size={16} className="text-primary flex-shrink-0" />
                <p className="text-gray-300">director@tcla-x.com</p>
              </div>

              <div className="flex items-start space-x-3">
                <Clock size={16} className="text-primary mt-1 flex-shrink-0" />
                <div className="text-gray-300">
                  <p>Monday - Friday: 8:00 AM - 5:00 PM</p>
                  <p>Saturday & Sunday: Closed</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © 2025 TCLA-X Limited. All rights reserved.
            </p>

            <div className="flex space-x-6 text-sm">
              <Link
                to="/privacy-policy"
                className="text-gray-400 hover:text-primary transition-smooth"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms-of-service"
                className="text-gray-400 hover:text-primary transition-smooth"
              >
                Terms of Service
              </Link>
              <Link
                to="/training-terms"
                className="text-gray-400 hover:text-primary transition-smooth"
              >
                Training Terms
              </Link>
              <Link
                to="/refund-policy"
                className="text-gray-400 hover:text-primary transition-smooth"
              >
                Refund Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
